import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=5c9ecf89&scoped=true"
import script from "./tab-bar.vue?vue&type=script&lang=js"
export * from "./tab-bar.vue?vue&type=script&lang=js"
import style0 from "./tab-bar.vue?vue&type=style&index=0&id=5c9ecf89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ecf89",
  null
  
)

export default component.exports